import { AxiosResponse } from 'axios'
import {useQuery, UseQueryOptions, useMutation, UseQueryResult, UseMutationOptions, UseMutationResult} from 'react-query'
import { APIEndpoints } from '../constants/api-endpoints'
import { QueryKeys }     from './_query_keys'
import { HttpRequest }  from '../services/_http'

export const useGetTemplatesTypesData = (searchOptions?:any, options?: UseQueryOptions): UseQueryResult <any> => {

    const method   = 'GET'
    const queryKey = [QueryKeys.TEMPLATES,searchOptions]

    return useQuery({
        queryKey,
        queryFn: () => HttpRequest({
            url: `${APIEndpoints.TemplatesTypes}`,
            params: searchOptions,
            method
        }),
        refetchOnWindowFocus:false,
        cacheTime: 0,
        ...options
    })
}

export const useGetWidgetByTemplates = (templateCode: string | undefined, options?: any) => {
    return useQuery(
        ['template-by-id', templateCode],
        () =>
            HttpRequest({
                url: `${APIEndpoints.TemplatesTypes}/code/${templateCode}`,
                method: 'GET',
            }),
        {
            enabled: !!templateCode,
            ...options,
        }
    )
}


/* =========================
   ADD Template Type
========================= */
export const useAddTemplatesTypeData = (
  options?: UseMutationOptions<any, any, any>
): UseMutationResult<any, any, any> => {

  const method = 'POST'

  return useMutation({
    mutationFn: (data: any) =>
      HttpRequest({
        url: `${APIEndpoints.TemplatesTypes}`,
        data,
        method,
      }),
    ...options,
  })
}

/* =========================
   UPDATE Template Type
========================= */
export const useUpdateTemplatesTypeData = (
  options?: UseMutationOptions<any, any, any>
): UseMutationResult<any, any, any> => {

  const method = 'PUT'

  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: any }) =>
      HttpRequest({
        url: `${APIEndpoints.TemplatesTypes}/${id}`,
        data,
        method,
      }),
    ...options,
  })
}

/* =========================
   DELETE Template Type
========================= */
export const useDeleteTemplatesTypeData = (
  options?: UseMutationOptions<any, any, any>
): UseMutationResult<any, any, any> => {

  const method = 'DELETE'

  return useMutation({
    mutationFn: ({ id }: { id: number }) =>
      HttpRequest({
        url: `${APIEndpoints.TemplatesTypes}/${id}`,
        method,
      }),
    ...options,
  })
}
